import { withErrorBoundary } from 'react-error-boundary';
import styled from 'styled-components';
import { ColorSystemNegative2, ColorSystemNegative5, Spacing8 } from 'autogen/design-tokens/tokens';
import type { UserMessage } from 'autogen/swagger/all';
import LinkActionButton from 'components/Button/LinkActionButton';
import Card from 'components/generic/card';
import { Typography } from 'components/generic/typography';
import WithIcon from 'components/hoc/withIcon/WithIcon';
import Icon from 'components/Icon';
import Flex from 'components/Layout/components/Flex';
import UserMessageToast from 'components/UserMessageToast';
import format from 'helpers/translations';

const StyleCard = styled(Card)`
    background-color: ${ColorSystemNegative5};
`;

const Content = ({ content, renderValidationSummary }) => {
    if (content) {
        return <Typography.Body as="span">{format(content)}</Typography.Body>;
    }

    if (renderValidationSummary) {
        return null; // When doing checkout layout.cshtml fix this render @Html.ValidationSummary()
    }

    return null;
};

function AlertUserMessage({ model }: { model: UserMessage }) {
    const { linkAction, linkText, content, showAsToast, renderValidationSummary, messageType, headline } = model;

    if (showAsToast) {
        return <UserMessageToast message={headline} type={messageType} />;
    }

    if (messageType !== 'Alert_Danger' && messageType !== 'Alert_Success') return null;

    return (
        <StyleCard>
            <Card.Content>
                <Flex
                    gap={Spacing8}
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent={{ xs: 'start', sm: 'space-between' }}
                    alignItems="start"
                >
                    <WithIcon icon={<Icon type="Alert" size={24} fill={ColorSystemNegative2} />}>
                        <Typography.Title size="S">{headline}</Typography.Title>
                    </WithIcon>
                    <Content content={content} renderValidationSummary={renderValidationSummary} />

                    {linkAction && linkText && (
                        <LinkActionButton size="sm" variant="club" action={linkAction}>
                            {linkText}
                        </LinkActionButton>
                    )}
                </Flex>
            </Card.Content>
        </StyleCard>
    );
}

export default withErrorBoundary(AlertUserMessage, {
    fallback: <div>Something went wrong</div>,
    onError(error, info) {
        console.error(error);
    }
});
